import { render, staticRenderFns } from "./discipline-selector.vue?vue&type=template&id=3b4194f1&"
import script from "./discipline-selector.vue?vue&type=script&lang=ts&"
export * from "./discipline-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports